import { AbstractControl, AbstractControlOptions, AsyncValidatorFn, FormGroup, ValidatorFn } from "@angular/forms";

export class EformGroup extends FormGroup {
    prefixEform: string;
    idInput: string;
    name: string;
    linkedIds: Array<String>;
    conditionsCreation: Array<String>;

    constructor(_prefixEform?: string, _idInput?: string, _name?, conditionsCreation?:Array<String>, controls?: {
      [key: string]: AbstractControl;
    }, validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null, asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
      super(controls, validatorOrOpts, asyncValidator);
      this.prefixEform = _prefixEform;
      this.idInput = _prefixEform + '|' + _idInput;
      this.name = _name?.replace('[]','');
      this.linkedIds = [];
      if (_idInput) {
        this.linkedIds.push(_idInput.split('_')[0])
      }
      this.conditionsCreation = conditionsCreation;
    }

    addLinkedId(_id){
      this.linkedIds.push(_id);
    }
  }
